// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--hUFt0";
export var heading__light = "heading-module--heading__light--lzAc4";
export var heading__weightNormal = "heading-module--heading__weightNormal--6fkHB";
export var large = "heading-module--large--OJLY6";
export var mb = "heading-module--mb--dTIcE";
export var mbLarge = "heading-module--mbLarge--3jpqB";
export var small = "heading-module--small--PqAtK";
export var subHeading = "heading-module--subHeading--sCdfE";
export var subSubHeading = "heading-module--subSubHeading--Nd4Al";
export var xSmall = "heading-module--xSmall--CyyK7";